export default __webpack_public_path__ + "static/media/poder_judicial.57d2ce7f.png";